import React from 'react';
import loadable from '@loadable/component';
import PropTypes from 'prop-types';
import Loading from 'Components/Loading';
import ApplicationLayout from 'Components/ApplicationLayout';
import pMinDelay from 'p-min-delay';

const BetSlip = loadable(() => pMinDelay(import('./BetSlip'), 300), {
  fallback: <Loading />
});

const AsyncBetSlip = props => {
  const pageConfig = {
    headerType: 'full',
    footerType: 'full',
    helmet: {
      bodyAttributes: {
        class: `${ props.userAgent.device?.type } bg-green`
      }
    }
  };

  return (
    <ApplicationLayout { ...pageConfig } { ...props }>
      <BetSlip { ...props } />
    </ApplicationLayout>
  );
};

AsyncBetSlip.propTypes = {
  userAgent: PropTypes.object
};

export default AsyncBetSlip;
